import React from 'react';
import PhantomEntryDisplay from './PhantomEntryDisplay';

function PhantomEntry3dDisplay(props) {
  return <PhantomEntryDisplay is3D {...props} />;
}

export default PhantomEntry3dDisplay;
